// Паспорт для визы (гражданство путешественника): выбор хранится в браузере (по умолчанию — Узбекистан),
// меняется сразу во всех виджетах — справке о направлении, документах тура и профиле
import { store as storage } from '../../shared/lib/storage';
import { createStore, useStore } from '../../shared/lib/store';

const KEY = 'visa:passport';
const valid = (v: unknown): string => (typeof v === 'string' && /^[A-Z]{2}$/.test(v) ? v : 'UZ');

/** Прежний выбор в «Документах для поездки» тура ('planner:passport') — тот же смысл, переносим */
const initial = (): string => valid(storage.get<string | null>(KEY, null) ?? storage.get<string>('planner:passport', 'UZ'));

export const passportStore = createStore<{ passport: string }>({ passport: initial() });
export const usePassport = (): string => useStore(passportStore).passport;

export function setPassport(cc: string): void {
  const passport = valid(cc);
  storage.set(KEY, passport);
  passportStore.set({ passport });
}
